/* =========================================================
   CartWizard Free-Gift Popup — LIVE popup ko modify karo
   Ye script apna popup nahi banata — jo popup CartWizard app
   khud DOM me daalti hai ([data-appname="CartWizard"]), usi ko
   dhoondh kar restyle + restructure karta hai.
   Existing "Add to cart" / "X" (close) buttons ke click
   handlers CartWizard app ke khud ke hain — unhe chhera nahi
   gaya hai, taaki functionality same rahe.
   ========================================================= */

(function () {
  const SELECTOR = '[data-appname="CartWizard"]';
  const PROCESSED_ATTR = "data-cw-enhanced";

  // ---------- 0) Config file se values uthao (fallback defaults bhi hain) ----------
  const userConfig = window.CW_GIFT_POPUP_CONFIG || {};
  const CFG = {
    text: Object.assign(
      {
        eyebrow: "FREE GIFT",
        heading: "Your Complimentary Gift",
        subtitle: "Add it to your bag below — on the house.",
        priceLabel: "YOURS, FREE",
        continueShoppingText: "Continue shopping",
      },
      userConfig.text || {}
    ),
    colors: Object.assign(
      {
        overlayBackground: "rgba(0,0,0,0.55)",
        popupBackground: "#f7f3ec",
        popupBorder: "#111111",
        eyebrowColor: "#b3893f",
        dividerColor: "#c9bfae",
        dividerDotBorder: "#c9bfae",
        headingColor: "#1a1a1a",
        subtitleColor: "#8a8578",
        productImageBoxBackground: "#ffffff",
        productImageBoxBorder: "#e6e0d3",
        productNameColor: "#1a1a1a",
        priceLabelColor: "#a6a196",
        buttonBackground: "#b3893f",
        buttonBackgroundHover: "#c9a35f",
        buttonTextColor: "#ffffff",
        continueShoppingColor: "#7d7a6f",
        closeButtonColor: "#333333",
      },
      userConfig.colors || {}
    ),
    sizes: Object.assign(
      {
        popupWidth: "340px",
        popupBorderWidth: "10px",
        productImageBoxWidth: "180px",
      },
      userConfig.sizes || {}
    ),
  };

  // Shopify color picker hex return karta hai (e.g. #000000).
  // Agar pehle se rgba/rgb ho to wahi use karo, warna hex ko
  // di gayi opacity ke saath rgba me convert karo.
  function hexToRgba(color, opacity) {
    if (!color) return `rgba(0,0,0,${opacity})`;
    if (color.startsWith("rgba") || color.startsWith("rgb")) return color;
    let hex = color.replace("#", "");
    if (hex.length === 3) {
      hex = hex.split("").map((c) => c + c).join("");
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  // ---------- 1) Design ke liye CSS inject karo (config se values liye) ----------
  function injectStyles() {
    if (document.getElementById("cw-gift-popup-override-styles")) return;
    const style = document.createElement("style");
    style.id = "cw-gift-popup-override-styles";
    style.textContent = `
      [data-appname="CartWizard"] .cw-popup-overlay{
        background:${hexToRgba(CFG.colors.overlayBackground, 0.55)} !important;
      }
      [data-appname="CartWizard"] .cw-popup-wrapper{
        width:${CFG.sizes.popupWidth} !important;
        max-width:90vw !important;
        background:${CFG.colors.popupBackground} !important;
        border:${CFG.sizes.popupBorderWidth} solid ${CFG.colors.popupBorder} !important;
        padding:34px 28px 28px !important;
        text-align:center !important;
        box-sizing:border-box !important;
        font-family:Arial, Helvetica, sans-serif !important;
      }
      /* Original "You got a free gift" text node ko chhupao */
      [data-appname="CartWizard"] .cw-popup-title{
        position:relative !important;
        font-size:0 !important;
        margin:0 0 4px !important;
      }
      [data-appname="CartWizard"] .cw-close-button-wrapper{
        position:absolute !important;
        top:-18px !important;
        right:-16px !important;
      }
      [data-appname="CartWizard"] .cw-close-button{
        font-size:16px !important;
        color:${CFG.colors.closeButtonColor} !important;
        cursor:pointer !important;
        display: flex;
        justify-content: end;
      }
      [data-appname="CartWizard"] .cw-eyebrow{
        font-size:11px;
        letter-spacing:3px;
        color:${CFG.colors.eyebrowColor};
        margin:20px 0 12px;
        font-family:Arial, sans-serif;
      }
      [data-appname="CartWizard"] .cw-divider{
        width:110px;
        height:1px;
        background:${CFG.colors.dividerColor};
        margin:0 auto 22px;
        position:relative;
      }
      [data-appname="CartWizard"] .cw-divider::before{
        content:"";
        position:absolute;
        left:50%; top:-3px;
        transform:translateX(-50%);
        width:6px; height:6px;
        border:1px solid ${CFG.colors.dividerDotBorder};
        border-radius:50%;
        background:${CFG.colors.popupBackground};
      }
      [data-appname="CartWizard"] .cw-heading-main{
        font-family:Georgia, 'Times New Roman', serif;
        font-style:italic;
        font-size:26px;
        color:${CFG.colors.headingColor};
        margin:0 0 12px;
        font-weight:400;
      }
      [data-appname="CartWizard"] .cw-popup-description{
        font-size:12.5px !important;
        color:${CFG.colors.subtitleColor} !important;
        margin:0 0 24px !important;
        min-height:0 !important;
      }
      [data-appname="CartWizard"] .cw-popup-product-image-wrapper{
        background:${CFG.colors.productImageBoxBackground} !important;
        border:1px solid ${CFG.colors.productImageBoxBorder} !important;
        padding:14px !important;
        width:${CFG.sizes.productImageBoxWidth} !important;
        margin:0 auto 18px !important;
        box-sizing:border-box !important;
      }
      [data-appname="CartWizard"] .cw-popup-product-image-wrapper img{
        display:block !important;
        width:100% !important;
        height:auto !important;
      }
      [data-appname="CartWizard"] .cw-popup-product-name{
        order:2 !important;
        font-weight:bold !important;
        font-size:15px !important;
        color:${CFG.colors.productNameColor} !important;
        margin-bottom:4px !important;
      }
      [data-appname="CartWizard"] .cw-popup-product-wrapper{
        display:flex !important;
        flex-direction:column !important;
      }
      [data-appname="CartWizard"] .cw-price-label{
        order:3;
        font-size:11px;
        letter-spacing:2px;
        color:${CFG.colors.priceLabelColor};
        margin-bottom:20px;
        font-family:Arial, sans-serif;
      }
      [data-appname="CartWizard"] .cw-popup-product-add-to-cart-button-wrapper{
        order:4 !important;
      }
      [data-appname="CartWizard"] .cw-popup-product-add-to-cart-button{
        width:100% !important;
        padding:15px 0 !important;
        background:${CFG.colors.buttonBackground} !important;
        color:${CFG.colors.buttonTextColor} !important;
        border:none !important;
        font-size:13px !important;
        letter-spacing:2px !important;
        cursor:pointer !important;
        transition:background .2s ease !important;
      }
      [data-appname="CartWizard"] .cw-popup-product-add-to-cart-button:hover{
        background:${CFG.colors.buttonBackgroundHover} !important;
      }
      [data-appname="CartWizard"] .cw-continue-shopping{
        display:inline-block;
        margin-top:16px;
        font-size:12px;
        color:${CFG.colors.continueShoppingColor};
        text-decoration:underline;
        cursor:pointer;
        font-family:Arial, sans-serif;
      }
    `;
    document.head.appendChild(style);
  }

  // ---------- 2) Live popup ke andar naye elements daalo ----------
  function enhancePopup(popupEl) {
    if (popupEl.getAttribute(PROCESSED_ATTR) === "true") return; // dobara process na ho
    popupEl.setAttribute(PROCESSED_ATTR, "true");

    const titleEl = popupEl.querySelector(".cw-popup-title");
    const descEl = popupEl.querySelector(".cw-popup-description");

    if (titleEl) {
      // Eyebrow + divider + naya heading title ke baad insert karo
      const eyebrow = document.createElement("div");
      eyebrow.className = "cw-eyebrow";
      eyebrow.textContent = CFG.text.eyebrow;

      const divider = document.createElement("div");
      divider.className = "cw-divider";

      const heading = document.createElement("div");
      heading.className = "cw-heading-main";
      heading.textContent = CFG.text.heading;

      titleEl.insertAdjacentElement("afterend", heading);
      titleEl.insertAdjacentElement("afterend", divider);
      titleEl.insertAdjacentElement("afterend", eyebrow);
    }

    if (descEl && !descEl.textContent.trim()) {
      descEl.textContent = CFG.text.subtitle;
    }

    // Har product ke naam ke baad price label add karo
    popupEl.querySelectorAll(".cw-popup-product-name").forEach((nameEl) => {
      if (nameEl.nextElementSibling && nameEl.nextElementSibling.classList.contains("cw-price-label")) return;
      const price = document.createElement("div");
      price.className = "cw-price-label";
      price.textContent = CFG.text.priceLabel;
      nameEl.insertAdjacentElement("afterend", price);
    });

    // "Continue shopping" link add karo (agar pehle se nahi hai)
    const wrapper = popupEl.querySelector(".cw-popup-wrapper");
    if (wrapper && !wrapper.querySelector(".cw-continue-shopping")) {
      const continueLink = document.createElement("div");
      continueLink.className = "cw-continue-shopping";
      continueLink.textContent = CFG.text.continueShoppingText;
      continueLink.addEventListener("click", function () {
        // Existing close button ko hi click karo — uska handler CartWizard app ka hai
        const closeBtn = popupEl.querySelector(".cw-close-button");
        if (closeBtn) closeBtn.click();
      });
      wrapper.appendChild(continueLink);
    }
  }

  // ---------- 3) Popup DOM me dhoondho (already present + future me aane wale dono) ----------
  function scanAndEnhance() {
    document.querySelectorAll(SELECTOR).forEach(enhancePopup);
  }

  function init() {
    injectStyles();
    scanAndEnhance(); // agar popup already load ho chuka hai

    // App popup ko dynamically DOM me daalti hai isliye observer lagao
    const observer = new MutationObserver(() => {
      scanAndEnhance();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
